import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSurveys = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "m6.61 9.114-1.094.85 2.272 2.4 3.209-3.25-.935-1.027-2.274 2.154-1.177-1.127Zm7.596-.104 1.257 1.257-1.256 1.175.934.923 1.236-1.312 1.249 1.312.81-.923-1.256-1.175 1.255-1.257-.81-.923-1.28 1.288-1.236-1.257-.902.892Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "m13.95 17.92.208-.272h7.663a.542.542 0 0 0 .179-.024V3.185c0-.077-.003-.13-.009-.167a.915.915 0 0 0-.17-.014H2.26a.97.97 0 0 0-.248.025.84.84 0 0 0-.012.156V17.65h7.993l.21.262m3.747.009.55.424m-.55-.424-.002.002-.005.006-.019.025-.073.094c-.575.745-1.156 1.485-1.74 2.223-.24-.29-.479-.58-.715-.873-.366-.452-.73-.904-1.093-1.358l-.075-.095-.02-.024-.005-.007v-.002m0 0-.546.433M2.02 3v.003",
		stroke: "currentColor",
		strokeWidth: 1.818
	})]
});
export default SvgSurveys;
